import { actions } from 'src/constants';

const LAST_DAILY_CHECK_KEY = 'kokolingo_last_daily_check_date';

const getLastDailyCheckDateFromStorage = () => {
  try {
    return localStorage.getItem(LAST_DAILY_CHECK_KEY);
  } catch (error) {
    console.error('Failed to read from localStorage:', error);
    return null;
  }
};

const saveLastDailyCheckDateToStorage = (date) => {
  try {
    localStorage.setItem(LAST_DAILY_CHECK_KEY, date);
  } catch (error) {
    console.error('Failed to save to localStorage:', error);
  }
};

const removeLastDailyCheckDateFromStorage = () => {
  try {
    localStorage.removeItem(LAST_DAILY_CHECK_KEY);
  } catch (error) {
    console.error('Failed to remove from localStorage:', error);
  }
};

const initialState = {
  messages: [],
  isLoading: false,
  hasError: false,
  errorMessage: null,
  isVisible: false,
  hasUnreadDailyMessage: false,
  lastDailyCheckDate: getLastDailyCheckDateFromStorage(),
};

const actionMap = {
  [actions.AI_CHAT_REQUEST]: (state, action) => ({
    ...state,
    messages: action.prompt
      ? [
          ...state.messages,
          {
            type: 'user',
            text: action.prompt,
            timestamp: Date.now(),
          },
        ]
      : state.messages,
    isLoading: true,
    hasError: false,
    errorMessage: null,
  }),

  [actions.AI_CHAT_SUCCESS]: (state, { result }) => ({
    ...state,
    messages: [
      ...state.messages,
      {
        type: 'ai',
        text: result.data.response,
        timestamp: Date.now(),
      },
    ],
    isLoading: false,
  }),

  [actions.AI_CHAT_FAILURE]: (state, { error }) => ({
    ...state,
    isLoading: false,
    hasError: true,
    errorMessage: error?.response?.data?.error || 'Failed to get AI response',
  }),

  [actions.AI_CHAT_RESET]: () => {
    removeLastDailyCheckDateFromStorage();

    return {
      ...initialState,
      lastDailyCheckDate: null,
    };
  },

  [actions.AI_CHAT_TOGGLE_VISIBILITY]: (state) => ({
    ...state,
    isVisible: !state.isVisible,
  }),

  [actions.AI_DAILY_CHECK_REQUEST]: (state) => ({
    ...state,
    isLoading: true,
  }),

  [actions.AI_DAILY_CHECK_SUCCESS]: (state, { result }) => {
    const dailyMessage = result.data.message;

    if (!dailyMessage) {
      return {
        ...state,
        isLoading: false,
      };
    }

    const today = new Date().toDateString();
    saveLastDailyCheckDateToStorage(today);

    return {
      ...state,
      messages: [
        {
          type: 'ai',
          text: dailyMessage,
          timestamp: Date.now(),
          isDailyCheck: true,
        },
      ],
      hasUnreadDailyMessage: true,
      lastDailyCheckDate: today,
      isLoading: false,
    };
  },

  [actions.AI_DAILY_CHECK_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [actions.AI_DAILY_MESSAGE_MARK_READ]: (state) => ({
    ...state,
    hasUnreadDailyMessage: false,
  }),
};

export default (state = initialState, action) => {
  if (actionMap[action.type]) {
    return actionMap[action.type](state, action);
  }
  return state;
};
